module.exports = __webpack_public_path__ + "a396bc8680f4477a258a96830b4d3c2f.png";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img2-en.png
// module id = 243
// module chunks = 2